<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-breadcrumbs>
        <v-breadcrumbs-item>Subscriptions</v-breadcrumbs-item>
        <v-breadcrumbs-item>{{$app.capitalizeFirstLetter($route.params.filter)}}</v-breadcrumbs-item>
        <v-breadcrumbs-item>{{$app.capitalizeFirstLetter(dayFilter)}}</v-breadcrumbs-item>
      </v-breadcrumbs>
      <connection-manager ref="connectionManager" v-model="connecting"></connection-manager>
      <v-card>
        <v-toolbar color="transparent"
                   dense
                   flat
                   card>
          <v-btn color="primary"
                 class="mx-4"
                 v-if="filter !== 'expired'"
                 @click.native="dayFilter = 'all'">
            All
          </v-btn>
          <v-btn color="primary"
                 class="mx-4"
                 v-if="filter !== 'expired'"
                 @click.native="dayFilter = 'today'">
            Today
          </v-btn>
          <v-btn color="primary"
                 class="mx-4"
                 v-if="filter !== 'expired'"
                 @click.native="dayFilter = 'tomorrow'">
            Tomorrow
          </v-btn>
          <v-btn color="primary"
                 class="mx-4"
                 @click.native="printForSupplier">
            Print for Supplier
          </v-btn>
          <v-btn color="primary"
                 class="mx-4"
                 @click.native="printForRider">
            Print for Rider
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          ref="subscriptionsTable"
          hide-actions>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.optionItem.name }}</td>
            <td class="text-xs-left">{{ transformWeekdays(props.item.weekdays) }}</td>
            <td class="text-xs-left">{{props.item.quantity}}</td>
            <td class="text-xs-left">{{ $app.formatMoney(props.item.itemCost) }}</td>
            <td class="text-xs-left">{{ $app.formatMoney(props.item.deliveryCost) }}</td>
            <td class="text-xs-left">
              {{ $app.formatMoney(props.item.itemCost+props.item.deliveryCost)}}
            </td>
            <td class="text-xs-left">
              <span v-if="props.item.renewEveryMonth">Renew monthly</span>
              <span v-else>Up to {{ props.item.terminationDate}}</span>
            </td>
            <td class="justify-center layout wrap px-0">
              <v-btn class="mx-0" color="primary" @click="viewItem(props.item)">
                Client Details
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <v-dialog v-model="viewItemDialog"
              max-width="600px">
      <v-card v-if="itemToView">
        <v-card-text>
          <v-data-table
            hide-headers
            hide-actions
            :headers="viewItemHeaders"
            :items="viewItemHeaders">
            <template slot="items" slot-scope="props">
              <td>{{props.item.text}}</td>
              <td>{{itemToView[props.item.value]}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="red darken-1"
                 flat
                 @click.native="viewItemDialog = false">Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <add-subscription-dialog :show="showAddSubscriptionDialog"
                             @onClose="onCloseAddSubscriptionDialog">
    </add-subscription-dialog>

    <v-fab-transition v-if="isDepartmentUser()">
      <v-btn class="ma-5"
             color="accent"
             fab
             dark
             fixed
             bottom
             @click.native="showAddSubscriptionDialog = true"
             right>
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>

  </v-layout>
</template>

<script>
  import ConnectionManager from './ConnectionManager'
  import Base from './Base.vue'
  import AddSubscriptionDialog from './AddSubscriptionDialog'
  import moment from 'moment'

  var jsPDF = require('jspdf')
  require('jspdf-autotable')

  export default {
    extends: Base,
    components: {
      AddSubscriptionDialog,
      ConnectionManager
    },
    name: 'admin-subscriptions',
    data () {
      return {
        showAddSubscriptionDialog: false,
        connecting: false,
        viewItemDialog: false,
        filter: null,
        itemToView: null,
        dayFilter: 'all',
        search: null,
        items: [],
        optionItemsIds: [],
        headers: [
          {text: 'Item', sortable: false, value: 'optionItem.name'},
          {text: 'Weekdays', sortable: false, value: 'weekdays'},
          {text: 'Quantity', sortable: false, value: 'quantity'},
          {text: 'Item Cost', sortable: false, value: 'item_cost'},
          {text: 'Delivery Cost', sortable: false, value: 'deliveryCost'},
          {text: 'Total Cost', sortable: false, value: 'amount'},
          {text: 'Duration', sortable: false, value: ''},
          {text: 'Action', sortable: false, value: ''}
        ],
        viewItemHeaders: [
          {text: 'Name', value: 'name'},
          {text: 'Email', value: 'email'},
          {text: 'Phone', value: 'phone'}
        ]
      }
    },
    watch: {
      '$route' (to, from) {
        // react to route changes...
        if (to.params.filter !== this.filter) {
          this.filter = to.params.filter
        }
      },
      filter (val) {
        if (val) {
          this.refresh()
        }
      },
      dayFilter (val) {
        if (val) {
          this.refresh()
        }
      }
    },
    computed: {

    },
    methods: {
      printForSupplier () {
        let groupedItems = this.groupItemsByOptionItems(this.items.slice())
        this.$app.log(groupedItems)
        let documentTitle = 'Supplier Report for '
        if (this.dayFilter === 'all') {
          documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions'
        } else if (this.dayFilter === 'today') {
          documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + moment().toDate().toDateString() + ')'
        } else {
          documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + moment().add(1, 'days').toDate().toDateString() + ')'
        }
        let rows = []
        for (let i = 0; i < this.optionItemsIds.length; i++) {
          rows.push([groupedItems[this.optionItemsIds[i]].optionItem.name, groupedItems[this.optionItemsIds[i]].quantity])
        }
        let columns = ['Item', 'Quantity']
        this.printDocument(documentTitle, rows, columns)
      },
      printForRider () {
        let documentTitle = 'Rider Report for '
        if (this.dayFilter === 'all') {
          documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions'
        } else if (this.dayFilter === 'today') {
          documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + moment().toDate().toDateString() + ')'
        } else {
          documentTitle = documentTitle + this.$app.capitalizeFirstLetter(this.filter) + ' Subscriptions (' + moment().add(1, 'days').toDate().toDateString() + ')'
        }
        let rows = []
        for (let i = 0; i < this.items.length; i++) {
          let item = this.items[i]
          rows.push([item.optionItem.name, item.quantity, item.user.client.name, item.user.client.phone, item.user.client.formattedAddress])
        }
        let columns = ['Item', 'Quantity', 'Client Name', 'Phone', 'Address']
        this.printDocument(documentTitle, rows, columns)
      },
      printDocument (documentTitle, rows, columns) {
        let doc = jsPDF({
          orientation: 'p',
          unit: 'mm',
          format: 'a4',
          hotfixes: [] // an array of hotfix strings to enable
        })
        let header = function (data) {
          doc.setFontSize(18)
          doc.setTextColor(26, 117, 186)
          doc.setFontStyle('helvetica')
          doc.setFontType('bold')
          // doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
          doc.text(documentTitle, data.settings.margin.left, 10)
        }
        let options = {
          addPageContent: header,
          margin: {
            top: 30
          },
          startY: 20
        }
        doc.autoTable(columns, rows, options)
        doc.save(this.$app.generateDocumentName(documentTitle) + '.pdf')
      },
      groupItemsByOptionItems (array) {
        const result = {}
        this.optionItemsIds = []
        let that = this
        array.forEach(item => {
          if (!result[item.optionItem.id]) {
            that.optionItemsIds.push(item.optionItem.id)
            result[item.optionItem.id] = Object.assign({}, item)
          } else {
            result[item.optionItem.id].quantity = result[item.optionItem.id].quantity + item.quantity
          }
        })
        return result
      },
      viewItem (item) {
        this.viewItemDialog = true
        this.itemToView = item.user.client
      },
      transformWeekdays (weekdays) {
        let weekdayNumbers = weekdays.split('#')
        let weekdayNames = []
        for (let weekdayNumber of weekdayNumbers) {
          weekdayNames.push(moment().weekday(weekdayNumber).format('dddd'))
        }
        return weekdayNames.join(',')
      },
      onCloseAddSubscriptionDialog (val) {
        this.showAddSubscriptionDialog = false
        if (val) {
          if (this.filter !== 'pendingApproval') {
            this.filter = 'pendingApproval'
          } else {
            this.refresh()
          }
        }
      },
      refresh () {
        let that = this
        that.items = []
        this.$refs.connectionManager.get('subscriptions', {
          onSuccess (response) {
            that.items = []
            that.items = that.items.concat(response.data.data)
          }
        }, {filter: this.filter, dayFilter: this.dayFilter})
      }
    },
    created () {
      this.filter = this.$route.params.filter
    },
    mounted () {
      this.filter = this.$route.params.filter
      this.dayFilter = 'all'
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminSubscriptions.vue